// extracted by mini-css-extract-plugin
module.exports = {"label":"_50479788","isSelected":"_c1efde3d"};